import classNames from 'classnames/bind';

import { FeatureFlags } from 'components/common/types/Features.types';
import DealsTable from 'components/pages/Deals/ProgrammaticDeals/DealsTable';
import { useHasFeatureAccess } from 'customHooks/useHasFeatureAccess';
import Filters from './Filters';
import styles from './ProgrammaticDeals.pcss';
import Metrics from './Metrics';

const cx = classNames.bind(styles);

const ProgrammaticDeals = (): React.ReactElement => {
  const hasOutOfChargeEnabled = useHasFeatureAccess(FeatureFlags.OUT_OF_CHARGE);
  const hasQuickDeliveryStatsEnabled = useHasFeatureAccess(FeatureFlags.QUICK_DELIVERY_STATS);

  return (
    <div className="py-4 px-14">
      <Metrics />
      <Filters />
      <div className={cx('deals mt-4')}>
        <DealsTable
          hasOutOfChargeEnabled={hasOutOfChargeEnabled}
          hasQuickDeliveryStatsEnabled={hasQuickDeliveryStatsEnabled}
        />
      </div>
    </div>
  );
};

export default ProgrammaticDeals;
